import {useLeadFormCloseSnapshotRef} from "./use_lead_form_close_snapshot_ref";
import {useLeadFormCloseTracking} from "./use_lead_form_close_tracking";

export const useLeadFormModalClose = (handleModalClose: (forceClose?: boolean) => void) => {
    const formCloseSnapshotRef = useLeadFormCloseSnapshotRef();
    const handleModalCloseWithTracking = useLeadFormCloseTracking(handleModalClose, formCloseSnapshotRef);

    return {formCloseSnapshotRef, handleModalCloseWithTracking};
};
import {useLeadFormCloseSnapshotRef} from "./use_lead_form_close_snapshot_ref";
import {useLeadFormCloseTracking} from "./use_lead_form_close_tracking";

export const useLeadFormModalClose = (handleModalClose: (forceClose?: boolean) => void) => {
    const formCloseSnapshotRef = useLeadFormCloseSnapshotRef();
    const handleModalCloseWithTracking = useLeadFormCloseTracking(handleModalClose, formCloseSnapshotRef);

    return {formCloseSnapshotRef, handleModalCloseWithTracking};
};
